import * as React from 'react'
import { DefaultContent } from 'react-content-engine'

import { Button } from 'components/Button'

import './ModalFooter.scss'

interface FooterProps {
  onClose: () => void
  onSave: () => void
  closeText?: string | JSX.Element
  saveText?: string | JSX.Element
  hideClose?: boolean
  hideSave?: boolean
  linkButton?: JSX.Element
  saveDisabled?: boolean
}

const ModalFooter: React.FC<FooterProps> = props => {
  return (
    <footer>
      {!props.hideClose ? (
        <div className="legend" onClick={props.onClose}>
          {props.closeText !== undefined ? (
            props.closeText
          ) : (
            <DefaultContent contentKey="close" addNode={false}>
              Close
            </DefaultContent>
          )}
        </div>
      ) : null}
      {!props.hideSave ? (
        <Button
          cutOff={'none'}
          onClick={props.onSave}
          disabled={props.saveDisabled}
        >
          {props.saveText !== undefined ? (
            props.saveText
          ) : (
            <DefaultContent contentKey="save" addNode={false}>
              Save
            </DefaultContent>
          )}
        </Button>
      ) : null}
      {props.linkButton ? props.linkButton : null}
    </footer>
  )
}

ModalFooter.defaultProps = {
  saveDisabled: false,
}

export { ModalFooter }
